// utils/routeByProductType.js
export const getProductLanding = (type) => {
  let path = "/admin/administration/user";
  let screen = "Administration";
  let subMenu = "Users";

  switch (type) {
    case "Administration":
      path = "/admin/administration/user";
      screen = "Administration";
      subMenu = "Users";
      break;
    case "People":
      path = "/admin/hrzone/employees";
      screen = "People";
      subMenu = "Employee";
      break;
    case "My Workspace":
      path = "/admin/myzone/status";
      screen = "My Workspace";
      subMenu = "Home";
      break;
    case "Payroll":
      // Payroll lands on Salary > Salary Components.
      path = "/admin/payroll/salary/salary-components";
      screen = "Payroll";
      subMenu = "Salary Configuration";
      break;
    case "Projects":
      path = "/admin/project/project-management";
      screen = "Projects";
      subMenu = "Projects";
      break;
    case "Team Workspace":
      // Team Workspace lands on Home (2026-10-01, user request). Users
      // without Home access are sent on to Attendance by HomeAccessGate.
      path = "/admin/teamzone/home";
      screen = "Team Workspace";
      subMenu = "Home";
      break;
    case "Support Admin":
    case "System Configuration":
      path = "/admin/support/admin";
      screen = "System Configuration";
      subMenu = "Product Control";
      break;
    case "Operations":
      path = "/admin/operations/worksessions";
      screen = "Operations";
      subMenu = "Work Sessions";
      break;
    case "CRM":
      path = "/admin/crm/dashboard-v2";
      screen = "CRM";
      subMenu = "Dashboard";
      break;
    default:
      path = "/admin/edit/profile/";
      screen = "Profile";
      subMenu = "";
  }

  return { path, screen, subMenu };
};

export const getAccessBasedRoute = (type) => {
  const { path, screen, subMenu } = getProductLanding(type);
  localStorage.setItem("currentScreen", screen);
  localStorage.setItem("currentSubMenu", subMenu);
  return path;
};
